


import React, { useState } from 'react';
import Header from './components/Header.tsx';
import ProjectIdeas from './components/ProjectIdeas.tsx';
import WoodIdentifier from './components/WoodIdentifier.tsx';
import JointsLibrary from './components/JointsLibrary.tsx';
import FinishCalculator from './components/FinishCalculator.tsx';
import StainVisualizer from './components/StainVisualizer.tsx';
import ToolStarterKit from './components/ToolStarterKit.tsx';
import DesignGenerator from './components/DesignGenerator.tsx';
import { CutListOptimizer } from './components/CutListOptimizer.tsx';
import { HammerIcon } from './components/icons/HammerIcon.tsx';
import { WoodLogIcon } from './components/icons/WoodLogIcon.tsx';
import { BookOpenIcon } from './components/icons/BookOpenIcon.tsx';
import { RulerIcon } from './components/icons/RulerIcon.tsx';
import { PaintBrushIcon } from './components/icons/PaintBrushIcon.tsx';
import { ToolboxIcon } from './components/icons/ToolboxIcon.tsx';
import { CutIcon } from './components/icons/CutIcon.tsx';
import { DraftingCompassIcon } from './components/icons/DraftingCompassIcon.tsx';
import { Tab } from './types.ts';


const TABS: Tab[] = [
    { id: 'projects', name: 'Project Ideas', icon: HammerIcon },
    { id: 'designer', name: 'Design Generator', icon: DraftingCompassIcon },
    { id: 'starter_kit', name: 'Tool Starter Kit', icon: ToolboxIcon },
    { id: 'cutlist', name: 'Cut List Optimizer', icon: CutIcon },
    { id: 'identifier', name: 'Wood Identifier', icon: WoodLogIcon },
    { id: 'joints', name: 'Joints Library', icon: BookOpenIcon },
    { id: 'calculator', name: 'Finish Calculator', icon: RulerIcon },
    { id: 'visualizer', name: 'Stain Visualizer', icon: PaintBrushIcon },
];

const App: React.FC = () => {
    const [activeTab, setActiveTab] = useState<string>('projects');

    const renderContent = () => {
        switch (activeTab) {
            case 'projects':
                return <ProjectIdeas />;
            case 'designer':
                return <DesignGenerator />;
            case 'starter_kit':
                return <ToolStarterKit />;
            case 'cutlist':
                return <CutListOptimizer />;
            case 'identifier':
                return <WoodIdentifier />;
            case 'joints':
                return <JointsLibrary />;
            case 'calculator':
                return <FinishCalculator />;
            case 'visualizer':
                return <StainVisualizer />;
            default:
                return <ProjectIdeas />;
        }
    };

    return (
        <div className="min-h-screen bg-stone-100 text-stone-800">
            <Header tabs={TABS} activeTab={activeTab} setActiveTab={setActiveTab} />
            <main className="p-4 sm:p-6 md:p-8">
                {renderContent()}
            </main>
            <footer className="text-center p-4 text-stone-500 text-sm">
                <p>Built with craftsmanship by the Gemini API</p>
            </footer>
        </div>
    );
};

export default App;